import { Component, OnInit } from '@angular/core';
import { ConfirmBookingScreen, PrimeBookingTicketDetail } from 'src/app/model/screen/confirm-booking-screen';
import {
  OfferPriceScreen,
  PassengerSeatDetail as OfferPriceScreenPassengerSeatDetail,
  PassengerSelectedSeatDetail as offerPriceScreenPassengerSelectedSeatDetail
} from 'src/app/model/screen/offer-price-screen';
import { Passenger as PassengerScreenPassenger, PassengerDetailScreen, PassengerSeatDetails } from 'src/app/model/screen/passenger-detail-screen';
import { DeckDetails, Passenger as seatSelectionPassenger, SeatDetail, SeatLayout, SeatSelectionScreen } from 'src/app/model/screen/seat-selection-screen';
import {
  PassengerSeatDetail as YourBookingScreenPassengerSeatDetail,
  PassengerSelectedSeatDetail as yourBookingScreenPassengerSelectedSeatDetail,
  YourBookingScreen
} from 'src/app/model/screen/your-booking-screen';
import { ApiService } from 'src/app/service/api.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';

@Component({
  selector: 'app-seat-selection-screen',
  templateUrl: './seat-selection-screen.component.html',
  styleUrls: ['./seat-selection-screen.component.scss']
})
export class SeatSelectionScreenComponent implements OnInit {
  confirmBookingScreen: ConfirmBookingScreen = {} as ConfirmBookingScreen;
  seatSelectionScreen: SeatSelectionScreen = {} as SeatSelectionScreen;

  public seatSelectionScreenXml: any = [];
  public seatColumn: any = [];
  public seatSelectionScreenXmlParse: any = [];

  public priceItemLists: any[] = [];
  public availableSeatsPriceList: any[] = [];
  public priceItemIds: any[] = [];
  public seatComponentList: any[] = [];
  public componentList: any[] = [];
  public colLayoutLeft: any[] = [];
  public colLayoutCenter: any[] = [];
  public colLayoutRight: any[] = [];
  public activePassengerIndex: any = 0;
  public activeSeatName: any = '';
  public selectedSeatsNames: any = [];
  public autoMovePassenger: 'Yes' | 'No' = 'Yes';
  public leftExit: any = [];
  public rightExit: any = [];
  public seatingRules: any = [];
  public seatingRulesList: any = [];
  public passengerDetailScreen: PassengerDetailScreen = this.sandboxPageStateService.getPassengerScreenDetail();
  public passengerSeatDetails: PassengerSeatDetails[] = [];
  public passengerScreenPassengerDetails: PassengerScreenPassenger[] = this.passengerDetailScreen.passengerDetail;
  public passengerSeatDetail: any = [];
  public disableExitRow: boolean = false;

  public activeCabin: any = 0;
  public adultDeckIndex: any = [];
  public adultRow: any = [];
  public disabledSeat: any = [];
  public disabledSeatPassengerRef: any = [];
  public flightDetails = {} as any;

  public serviceDefinitionIds: any = [];
  public serviceDefinitionList: any = [];

  public seatFlightNumber: any = '';
  constructor(private sandboxPageStateService: SandboxPageStateService, private apiService: ApiService) {}

  ngOnInit(): void {
    this.confirmBookingScreen = this.sandboxPageStateService.getConfirmBookingScreenData();
    this.seatSelectionScreen = this.sandboxPageStateService.getSeatSelectionScreenData();
    this.seatFlightNumber = this.seatSelectionScreen.flightNumber;
    if (this.seatSelectionScreen.bookingType === 'offer-price-screen-seat') {
      let offerPriceScreenData = this.sandboxPageStateService.getOfferPriceScreenData();
      this.flightDetails = offerPriceScreenData.offerPrice.boundAirlineOffer[this.seatSelectionScreen.boundOfferIndex].flightDetails[this.seatSelectionScreen.flightSegmentIndex];
    } else if (this.seatSelectionScreen.bookingType === 'your-booking-screen-seat') {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      this.flightDetails = yourBookingScreenData.booking.boundAirlineOffer[this.seatSelectionScreen.boundOfferIndex].flightsDetails[this.seatSelectionScreen.flightSegmentIndex];
    }
    this.initSeatSelectionScreenMapping();
  }

  setActivePassenger(passengerIndex: any) {
    let passengerList = this.seatSelectionScreen.passengerDetail;
    let totalPassenger = passengerList.length;
    let index = 0;
    if (totalPassenger > 0) {
      this.seatSelectionScreen.passengerDetail.forEach((passenger: seatSelectionPassenger) => {
        let isSelectedPassenger = false;
        if (index === passengerIndex) {
          isSelectedPassenger = true;
          this.activePassengerIndex = index;
          this.activeSeatName = passenger.selectedRowNumber + '|' + passenger.selectedColumnName;
        }
        this.seatSelectionScreen.passengerDetail[index].activePasssenger = isSelectedPassenger;
        index++;
      });
    }
  }
  updateActivePassenger(passengerIndex: any) {
    this.autoMovePassenger = 'No';
    this.setActivePassenger(passengerIndex);
  }
  chechk_active_seat(rowName: any, colName: any) {
    let seatName = rowName + '|' + colName;
    if (seatName === this.activeSeatName) {
      return true;
    } else {
      return false;
    }
  }
  chech_selected_seat(rowName: any, colName: any) {
    let seatName = rowName + '|' + colName;
    let rowIndex: any = this.selectedSeatsNames.indexOf(seatName);
    if (rowIndex !== -1) {
      return true;
    } else {
      return false;
    }
  }

  mapSeatingRules(rulesList: any) {
    this.seatingRules = [];
    let rulesListLength = rulesList.length;
    if (rulesListLength > 0) {
      rulesList.forEach((rules: any) => {
        this.seatingRules.push(rules.TEXT[0]);
      });
    }
  }

  initSeatSelectionScreenMapping() {
    if (this.seatSelectionScreen.jsonData) {
      this.seatSelectionScreen.passengerDetail = [];
      let seatSelectionJsonData = this.seatSelectionScreen.jsonData;
      let seatEnvelop = seatSelectionJsonData['SOAP:ENVELOPE'];
      let seatBody = seatEnvelop['SOAP:BODY'][0];
      let seatAvailabilities = seatBody['SEATAVAILABILITYRS'][0];
      let seatCartOffer = seatAvailabilities['ALACARTEOFFER'][0];
      let seatCartOfferItem = seatCartOffer['ALACARTEOFFERITEM'];
      this.priceItemLists = seatCartOfferItem;
      this.mapOfferItem(seatCartOfferItem);
      let seatDataLists = seatAvailabilities['DATALISTS'][0];
      this.serviceDefinitionList = seatDataLists.SERVICEDEFINITIONLIST[0].SERVICEDEFINITION;
      this.mapServiceDefinition(this.serviceDefinitionList);

      let addSeatResponseId = seatAvailabilities.SHOPPINGRESPONSEID[0].RESPONSEID[0];
      this.seatSelectionScreen.offerId = seatCartOffer.$.OFFERID;
      this.seatSelectionScreen.owner = seatCartOffer.$.OWNER;
      this.seatSelectionScreen.responseID = addSeatResponseId;
      let passengerList = seatDataLists.PASSENGERLIST[0].PASSENGER;
      this.mapPassengerDetail(passengerList);
      let seatingRulesList = seatDataLists.DISCLOSURELIST[0].DISCLOSURES[0].DESCRIPTION;
      this.mapSeatingRules(seatingRulesList);
      let seatMapLists = seatAvailabilities['SEATMAP'];
      seatMapLists.forEach((seatMapList: any) => {
        let segmentRef = seatMapList['SEGMENTREF'][0];
        if (segmentRef === this.seatFlightNumber) {
          let seatMap = seatMapList['SEATMAP'];
          let cabinList = seatMapList['CABIN'];
          let cabinIndex = 0;
          cabinList.forEach((cabin: any) => {
            this.seatSelectionScreen.deckDetails.push({
              layout: [],
              isUpperDeck: cabin.$.UPPERDECKIND,
              exitLeftRow: [],
              exitRightRow: [],
              rowsNumbers: [],
              columnNames: [],
              colLayout: [],
              avilableSeatsRows: [],
              avilableSeatsColumns: []
            });
            this.mapExitRow(cabin, cabinIndex);
            this.mapSeatSelectionScreen(cabin, cabinIndex);
            cabinIndex++;
          });
        }
      });
    } else {
      // console.log('this.seatSelectionScreen.jsonData is undefined');
    }
  }
  mapServiceDefinition(serviceDefinitionList: any) {
    this.serviceDefinitionIds = [];
    serviceDefinitionList.forEach((serviceDefinition: any) => {
      this.serviceDefinitionIds.push(serviceDefinition.$.SERVICEDEFINITIONID);
    });
  }
  checkAlreadyUsedSeat(rowNumber: any, colName: any) {
    let ref = rowNumber + '-' + colName;
    let rowIndex: any = this.disabledSeat.indexOf(ref);
    if (rowIndex !== -1) {
      return true;
    } else {
      return false;
    }
  }
  getUsedPassengerId(rowNumber: any, colName: any) {
    let ref = rowNumber + '-' + colName;
    let rowIndex: any = this.disabledSeat.indexOf(ref);
    if (rowIndex !== -1) {
      return this.disabledSeatPassengerRef[rowIndex];
    } else {
      return false;
    }
  }
  mapPassengerDetail(passengerList: any) {
    let boundOfferIndex = this.seatSelectionScreen.boundOfferIndex;
    let flightSegmentIndex = this.seatSelectionScreen.flightSegmentIndex;
    let passengerSelectedSeatLists: any = [];
    let passengerSelectedSeatListsLength: any = 0;
    if (this.seatSelectionScreen.bookingType === 'offer-price-screen-seat') {
      let offerPriceScreenData = this.sandboxPageStateService.getOfferPriceScreenData();
      passengerSelectedSeatLists = offerPriceScreenData.offerPrice.boundAirlineOffer[boundOfferIndex].flightDetails[flightSegmentIndex].passengerSeatDetail;
    } else if (this.seatSelectionScreen.bookingType === 'your-booking-screen-seat') {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      passengerSelectedSeatLists = yourBookingScreenData.booking.boundAirlineOffer[boundOfferIndex].flightsDetails[flightSegmentIndex].passengerSeatDetail;
    }
    passengerSelectedSeatListsLength = passengerSelectedSeatLists.length;
    let totalPassenger = passengerList.length;
    if (totalPassenger > 0) {
      let i = 0;
      passengerList.forEach((passenger: any) => {
        if (passenger.PTC[0] === 'INF') {
          this.disableExitRow = true;
        }
        let activePasssenger = false;
        if (i === 0) {
          activePasssenger = true;
          i++;
        }
        let selectedRowNumber = '';
        let selectedSeatPrice = '0';
        let selectedColumnName = 'No Seat';
        let selectedOfferItemRef = '';
        let selectedDeckIndex = '';
        let descriptions: any;
        let price: any = '';
        let currency: any = '';
        if (passengerSelectedSeatListsLength > 0) {
          passengerSelectedSeatLists.forEach((passengerSelectedSeatList: any) => {
            if (passengerSelectedSeatList.passengerId === passenger.$.PASSENGERID) {
              selectedOfferItemRef = passengerSelectedSeatList.selectedOfferItemRef;
              if (selectedOfferItemRef !== '') {
                selectedRowNumber = passengerSelectedSeatList.selectedRowNumber;
                selectedColumnName = passengerSelectedSeatList.selectedColumnName;
                selectedSeatPrice = passengerSelectedSeatList.selectedSeatPrice;
                selectedOfferItemRef = passengerSelectedSeatList.selectedOfferItemRef;
                selectedDeckIndex = passengerSelectedSeatList.selectedDeckIndex;
                descriptions = passengerSelectedSeatList.descriptions;
                price = passengerSelectedSeatList.price;
                currency = passengerSelectedSeatList.currency;
                this.selectedSeatsNames.push(passengerSelectedSeatList.selectedRowNumber + '|' + passengerSelectedSeatList.selectedColumnName);
              }
              if (selectedOfferItemRef === '') {
                this.disabledSeat.push(passengerSelectedSeatList.selectedRowNumber + '-' + passengerSelectedSeatList.selectedColumnName);
                this.disabledSeatPassengerRef.push(passengerSelectedSeatList.passengerId);
              }
            }
          });
        }
        let passengerDetail: seatSelectionPassenger = {
          passengerId: passenger.$.PASSENGERID,
          passengerType: passenger.PTC[0],
          selectedRowNumber: selectedRowNumber,
          selectedColumnName: selectedColumnName,
          activePasssenger: activePasssenger,
          selectedPrice: selectedSeatPrice,
          selectedOfferItemRef: selectedOfferItemRef,
          selectedDeckIndex: selectedDeckIndex,
          descriptions: descriptions,
          price: price,
          currency: currency
        };
        if (passenger.PTC[0] !== 'INF') {
          this.seatSelectionScreen.passengerDetail.push(passengerDetail);
        }
      });
      this.setActivePassenger(0);
    }
  }

  mapOfferItem(priceData: any) {
    this.priceItemIds = [];
    let count = priceData.length;
    if (count > 0) {
      priceData.forEach((y: any) => {
        this.priceItemIds.push(y.$.OFFERITEMID);
      });
    }
  }

  mapSeatSelectionScreen(cabinData: any, cabinIndex: any) {
    let cabinLayoutData = cabinData['CABINLAYOUT'];
    let cabinComponent = cabinData['COMPONENT'];
    this.seatComponentList = cabinComponent;
    this.availableSeatsPriceList = cabinData['ROW'];
    this.mapAvailableSeats(cabinData['ROW'], cabinIndex);
    this.seatSelectionScreen.deckDetails[cabinIndex].layout = this.mapSeatLayout(cabinLayoutData[0], cabinIndex);
    let componentLength = this.seatComponentList.length;
    if (componentLength > 0) {
      this.seatComponentList.forEach((y: any) => {
        let componentType = y.TYPE[0];
        let positionDetail = y.LOCATION[0].ROWPOSITION[0];
        let rowNumber = positionDetail.BEGIN[0];
        let rowIndex: any = this.seatSelectionScreen.deckDetails[cabinIndex].rowsNumbers.indexOf(rowNumber);
        let colNumber = positionDetail.COLUMNPOSITION[0];
        if (componentType === 'OTH') {
          let columnIndex: any = this.seatSelectionScreen.deckDetails[cabinIndex].colLayout.indexOf(colNumber);
          if (columnIndex != '-1') {
            this.seatSelectionScreen.deckDetails[cabinIndex].layout[rowIndex].leftColumnLayout[columnIndex].isOTH = true;
          }
        }
      });
    }
  }

  mapAvailableSeats(avilableSeatsLists: any, cabinIndex: any) {
    this.seatSelectionScreen.deckDetails[cabinIndex].avilableSeatsRows = [];
    this.seatSelectionScreen.deckDetails[cabinIndex].avilableSeatsColumns = [];
    let count = avilableSeatsLists.length;
    if (count > 0) {
      avilableSeatsLists.forEach((y: any) => {
        let rowNumber: any = y.NUMBER[0];
        let seatsLists: any = y.SEAT;
        let seatCount = seatsLists.length;
        this.seatSelectionScreen.deckDetails[cabinIndex].avilableSeatsRows.push(rowNumber);
        let avilableSeats: any = {};
        avilableSeats['row'] = rowNumber;
        avilableSeats['columns'] = [];
        if (seatCount > 0) {
          seatsLists.forEach((x: any) => {
            avilableSeats['columns'].push(x.COLUMN[0]);
          });
        }
        this.seatSelectionScreen.deckDetails[cabinIndex].avilableSeatsColumns.push(avilableSeats);
      });
    }
  }

  mapSeatLayout(cabinLayoutData: any, cabinIndex: any) {
    let columns = cabinLayoutData['COLUMNS'];
    this.seatColumn = columns;
    let row = cabinLayoutData['ROWS'][0];
    this.mapLayoutRows(row['FIRST'][0], row['LAST'][0], cabinIndex);
    this.mapLayoutColumns(columns, cabinIndex);
    this.mapSplitColumn(cabinIndex);
    let rowLength = this.seatSelectionScreen.deckDetails[cabinIndex].rowsNumbers.length;
    let columnLength: any = this.seatSelectionScreen.deckDetails[cabinIndex].columnNames.length;
    let left = columnLength;
    var layouts: any[] = [];
    if (rowLength > 0) {
      this.seatSelectionScreen.deckDetails[cabinIndex].rowsNumbers.forEach((rowNumber: any) => {
        let availableSeatRowIndex: any = this.seatSelectionScreen.deckDetails[cabinIndex].avilableSeatsRows.indexOf(rowNumber);
        var start = 0;
        var end = left;
        let leftColumnLayout = this.layoutColumn(start, end, availableSeatRowIndex, cabinIndex);
        let layout: SeatLayout = {
          leftColumnLayout: leftColumnLayout,
          rowNumber: rowNumber
        };
        layouts.push(layout);
      });
    }
    return layouts;
  }

  mapSplitColumn(cabinIndex: any) {
    let columnLength = this.seatSelectionScreen.deckDetails[cabinIndex].columnNames.length;
    let left = columnLength;
    for (let i = 0; i < columnLength; i++) {
      let cName = this.seatColumn[i];
      if (typeof cName.$ != 'undefined') {
        cName = cName._;
      }
      this.seatSelectionScreen.deckDetails[cabinIndex].colLayout.push(cName);
    }
  }

  layoutColumn(start: number, end: number, availableSeatRowIndex: any, cabinIndex: any) {
    let columnSeats: any = [];
    for (let i = start; i < end; i++) {
      let selectedColumn = this.seatColumn[i];
      let positionType = '';
      let displayEmptyBox = false;
      let seatColumnName = selectedColumn;
      let isMiddleSeat = true;
      if (typeof selectedColumn.$ !== 'undefined') {
        seatColumnName = selectedColumn._;
        positionType = selectedColumn.$.POSITION;
        isMiddleSeat = false;
      }
      if (positionType === 'A') {
        if (this.seatColumn[i + 1] !== 'undefined') {
          let nextSelectedColumn = this.seatColumn[i + 1];
          if (typeof nextSelectedColumn.$ !== 'undefined' && nextSelectedColumn.$.POSITION === 'A') {
            displayEmptyBox = true;
          }
        }
      }
      let colName = seatColumnName;
      let price: any = 0;
      let currency = 'USD';
      let isSeatAvailable = false;
      let isOTH = false;
      let seatDescription: any = '';
      let selAvailSeatOfferRef = '';
      if (availableSeatRowIndex != '-1') {
        let selectedColumn = this.seatSelectionScreen.deckDetails[cabinIndex].avilableSeatsColumns[availableSeatRowIndex].columns;
        let availableSeatColumnIndex = selectedColumn.indexOf(colName);
        if (availableSeatColumnIndex != '-1') {
          let selAvailPrice = this.availableSeatsPriceList[availableSeatRowIndex].SEAT;
          selAvailSeatOfferRef = selAvailPrice[availableSeatColumnIndex].OFFERITEMREFS && selAvailPrice[availableSeatColumnIndex].OFFERITEMREFS[0];
          let priceOfferIndex: any = this.priceItemIds.indexOf(selAvailSeatOfferRef);
          if (priceOfferIndex != '-1') {
            let selPrice = this.priceItemLists[priceOfferIndex];
            let seatDescriptionRef = selPrice.SERVICE[0].SERVICEDEFINITIONREF[0];
            let serviceDefinitionListIndex: any = this.serviceDefinitionIds.indexOf(seatDescriptionRef);
            let selectedServiceDefinitionList = this.serviceDefinitionList[serviceDefinitionListIndex];
            seatDescription = selectedServiceDefinitionList.DESCRIPTIONS;
            let priceDetail = selPrice.UNITPRICEDETAIL[0].TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0];
            price = priceDetail._;
            currency = priceDetail.$.CODE;
            isSeatAvailable = true;
          }
        }
      }
      let columnSeat: SeatDetail = {
        displayEmptyBox: displayEmptyBox,
        seatPositionType: positionType,
        seatColumnName: seatColumnName,
        isMiddleSeat: isMiddleSeat,
        price: price,
        currency: currency,
        isSeatAvailable: isSeatAvailable,
        isOTH: isOTH,
        offerItemId: selAvailSeatOfferRef,
        seatDescription: seatDescription
      };
      columnSeats.push(columnSeat);
    }
    return columnSeats;
  }

  mapExitRow(cabinData: any, cabinIndex: any) {
    let cabinLayout: any = cabinData['CABINLAYOUT'][0];
    if (typeof cabinLayout['EXITROWPOSITION'] !== 'undefined') {
      let exitPosition = cabinLayout['EXITROWPOSITION'][0]['ROWPOSITION'];
      let exitPositionLength = exitPosition.length;
      if (exitPositionLength > 0) {
        exitPosition.forEach((position: any) => {
          this.seatSelectionScreen.deckDetails[cabinIndex].exitLeftRow.push(position.FIRST[0]);
          this.seatSelectionScreen.deckDetails[cabinIndex].exitRightRow.push(position.LAST[0]);
        });
      }
    }
  }

  checkExitRow(rowNumber: any, type: 'left' | 'right', deckIndex: any) {
    let result: boolean = false;
    let rowIndex: any = '';
    if (type === 'left') {
      rowIndex = this.seatSelectionScreen.deckDetails[deckIndex].exitLeftRow.indexOf(rowNumber);
    }
    if (type === 'right') {
      rowIndex = this.seatSelectionScreen.deckDetails[deckIndex].exitRightRow.indexOf(rowNumber);
    }
    if (rowIndex !== '' && rowIndex !== -1) {
      result = true;
    }
    return result;
  }

  mapLayoutRows(rowStart: any, rowEnd: any, cabinIndex: any) {
    this.seatSelectionScreen.deckDetails[cabinIndex].rowsNumbers = [];
    let i = rowStart;
    rowStart = parseInt(rowStart);
    rowEnd = parseInt(rowEnd);
    for (let i = rowStart; i <= rowEnd; i++) {
      let rowNumberString = i.toString();
      this.seatSelectionScreen.deckDetails[cabinIndex].rowsNumbers.push(rowNumberString);
    }
  }

  mapLayoutColumns(columnList: any, cabinIndex: any) {
    this.seatSelectionScreen.deckDetails[cabinIndex].columnNames = [];
    let count = columnList.length;
    if (count > 0) {
      columnList.forEach((y: any) => {
        if (typeof y.$ != 'undefined') {
          this.seatSelectionScreen.deckDetails[cabinIndex].columnNames.push(y._);
        } else {
          this.seatSelectionScreen.deckDetails[cabinIndex].columnNames.push(y);
        }
      });
    }
  }

  makeSelected(row: number, type: 'left' | 'center' | 'right', col: number, isSeatAvailable: boolean, deckIndex: any) {
    if (isSeatAvailable) {
      let selRow = this.seatSelectionScreen.deckDetails[deckIndex].layout[row];
      let selCol: any = {};
      if (type === 'left') {
        selCol = selRow.leftColumnLayout[col];
        let columnName = selRow.leftColumnLayout[col].seatColumnName;
        let rowNumber = selRow.rowNumber;
        let seatNumber = rowNumber + '|' + columnName;
        let selectedSeatIndex: any = this.selectedSeatsNames.indexOf(seatNumber);
        if (selectedSeatIndex === -1) {
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].selectedColumnName = columnName;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].selectedPrice = selRow.leftColumnLayout[col].price;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].selectedOfferItemRef = selRow.leftColumnLayout[col].offerItemId;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].selectedDeckIndex = deckIndex;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].descriptions = selRow.leftColumnLayout[col].seatDescription;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].price = selRow.leftColumnLayout[col].price;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].currency = selRow.leftColumnLayout[col].currency;
          this.seatSelectionScreen.passengerDetail[this.activePassengerIndex].selectedRowNumber = rowNumber;
        }
      }
      let totalPassenger = this.seatSelectionScreen.passengerDetail.length;
      this.selectedSeatsNames = [];
      let totPassenger = this.seatSelectionScreen.passengerDetail.length;
      if (this.autoMovePassenger === 'Yes') {
        if (this.activePassengerIndex >= totPassenger - 1) {
          this.activePassengerIndex = 0;
        } else {
          this.activePassengerIndex = this.activePassengerIndex + 1;
        }
      } else {
        this.autoMovePassenger = 'Yes';
      }
      this.setActivePassenger(this.activePassengerIndex);
      if (totalPassenger > 0) {
        this.seatSelectionScreen.passengerDetail.forEach((passenger: seatSelectionPassenger) => {
          this.selectedSeatsNames.push(passenger.selectedRowNumber + '|' + passenger.selectedColumnName);
        });
      }
    }
  }

  updateSeat() {
    this.passengerSeatDetail = [];
    let totalPassenger = this.seatSelectionScreen.passengerDetail.length;
    let errorInseatIsAllocateForEveryPassenger: boolean = false;
    let isExitSeatAllocateToChild: boolean = false;
    let childDifferentDeckIssue: boolean = false;
    let adultAndChildNotInSameRow: boolean = false;
    if (totalPassenger > 0) {
      this.adultDeckIndex = [];
      this.seatSelectionScreen.passengerDetail.forEach((passenger: seatSelectionPassenger) => {
        if (passenger.selectedRowNumber === '') {
          errorInseatIsAllocateForEveryPassenger = true;
        }
        if (passenger.passengerType === 'CHD') {
          this.seatSelectionScreen.deckDetails.forEach((deckDetail: DeckDetails) => {
            let leftxitRowIndex: any = deckDetail.exitLeftRow.indexOf(passenger.selectedRowNumber);
            if (leftxitRowIndex !== -1) {
              isExitSeatAllocateToChild = true;
            }
            let rightRowIndex: any = deckDetail.exitRightRow.indexOf(passenger.selectedRowNumber);
            if (rightRowIndex !== -1) {
              isExitSeatAllocateToChild = true;
            }
          });
          let deckIndex: any = this.adultDeckIndex.indexOf(passenger.selectedDeckIndex);
          if (deckIndex === -1) {
            childDifferentDeckIssue = true;
          }
          let childRow: any = parseInt(passenger.selectedRowNumber);
          let parentRowIndexForChildRow: any = this.adultRow.indexOf(childRow);
          if (parentRowIndexForChildRow === -1) {
            childRow = childRow - 1;
            parentRowIndexForChildRow = this.adultRow.indexOf(childRow);
            if (parentRowIndexForChildRow === -1) {
              childRow = childRow + 2;
              parentRowIndexForChildRow = this.adultRow.indexOf(childRow);
              if (parentRowIndexForChildRow === -1) {
                adultAndChildNotInSameRow = true;
              }
            }
          }
        } else {
          this.adultDeckIndex.push(passenger.selectedDeckIndex);
          this.adultRow.push(parseInt(passenger.selectedRowNumber));
        }
        this.passengerSeatDetail.push({
          passengerId: passenger.passengerId,
          passengerType: passenger.passengerType,
          selectedRowNumber: passenger.selectedRowNumber,
          selectedColumnName: passenger.selectedColumnName,
          selectedSeatPrice: passenger.selectedPrice,
          selectedOfferItemRef: passenger.selectedOfferItemRef,
          selectedDeckIndex: passenger.selectedDeckIndex,
          descriptions: passenger.descriptions,
          price: passenger.price,
          currency: passenger.currency
        });
      });
    }
    if (errorInseatIsAllocateForEveryPassenger) {
      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { showError: 'Yes', errorMessage: 'Please Select Seats for All Passengers' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else if (isExitSeatAllocateToChild) {
      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { showError: 'Yes', errorMessage: '1 or More Passengers not eligible for Selected Seat' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else if (childDifferentDeckIssue) {
      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { showError: 'Yes', errorMessage: '1 or More Passengers not eligible for Selected Seat' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else if (adultAndChildNotInSameRow) {
      let patchSandboxSourceData: any = '';
      patchSandboxSourceData = { showError: 'Yes', errorMessage: '1 or More Passengers not eligible for Selected Seat' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      if (this.seatSelectionScreen.bookingType === 'offer-price-screen-seat') {
        this.storeOfferPricePrimeBooking();
      } else if (this.seatSelectionScreen.bookingType === 'your-booking-screen-seat') {
        this.storeYourBookingPostSaleSeat();
      }
    }
  }
  storeYourBookingPostSaleSeat() {
    let boundOfferIndex = this.seatSelectionScreen.boundOfferIndex;
    let flightSegmentIndex = this.seatSelectionScreen.flightSegmentIndex;
    let yourBookingScreenData: YourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    // store offer id to make order create request
    let yourBookingScreenPassengerSeatDetail = yourBookingScreenData.selectedSeatItem;
    let yourBookingScreenPassengerSeatDetailLength = yourBookingScreenPassengerSeatDetail.length;
    let updatedYourBookingScreenSelectedSeatDetails: yourBookingScreenPassengerSelectedSeatDetail[] = [];
    if (yourBookingScreenPassengerSeatDetailLength > 0) {
      yourBookingScreenPassengerSeatDetail.forEach((seatDetail: yourBookingScreenPassengerSelectedSeatDetail) => {
        if (seatDetail.boundOfferIndex === boundOfferIndex && seatDetail.flightIndex === flightSegmentIndex) {
        } else {
          updatedYourBookingScreenSelectedSeatDetails.push(seatDetail);
        }
      });
    }
    let selectedSeatDetail: offerPriceScreenPassengerSelectedSeatDetail = {
      offerId: this.seatSelectionScreen.offerId,
      owner: this.seatSelectionScreen.owner,
      responseId: this.seatSelectionScreen.responseID,
      offerDetail: [],
      boundOfferIndex: boundOfferIndex,
      flightIndex: flightSegmentIndex
    };
    //end
    yourBookingScreenData.booking.boundAirlineOffer[boundOfferIndex].flightsDetails[flightSegmentIndex].passengerSeatDetail = this.passengerSeatDetail;
    //store into passenger detail screen
    let passengerIndex = 0;
    let totSeatPrice: any = 0;
    this.passengerScreenPassengerDetails.forEach((passengerDetail: PassengerScreenPassenger) => {
      this.passengerSeatDetail.forEach((passenger: OfferPriceScreenPassengerSeatDetail) => {
        if (passenger.passengerId === passengerDetail.passengerId) {
          selectedSeatDetail.offerDetail.push({
            passengerId: passenger.passengerId,
            offerItemID: passenger.selectedOfferItemRef,
            seatDetail: {
              row: passenger.selectedRowNumber,
              column: passenger.selectedColumnName
            },
            descriptions: passenger.descriptions,
            price: passenger.price,
            currency: passenger.currency
          });
          let selectedPassengerSeatDetails: PassengerSeatDetails[] = passengerDetail.passengerOtherDetails.passengerSelectedSeatDetails;
          let selectedPassengerScreenLength = selectedPassengerSeatDetails.length;
          let addAsNewSelectedSeat: boolean = true;
          let selectedSeatIndex = 0;
          if (selectedPassengerScreenLength > 0) {
            selectedPassengerSeatDetails.forEach((selectedPassengerSeatDetail: PassengerSeatDetails) => {
              if (addAsNewSelectedSeat) {
                if (selectedPassengerSeatDetail.boundOfferIndex === boundOfferIndex && selectedPassengerSeatDetail.flightIndex === flightSegmentIndex) {
                  this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedSeatDetails[selectedSeatIndex] = {
                    seatRowNumber: passenger.selectedRowNumber,
                    seatCoulmnName: passenger.selectedColumnName,
                    seatPrice: passenger.selectedSeatPrice,
                    boundOfferIndex: boundOfferIndex,
                    flightIndex: flightSegmentIndex,
                    flightNumber: this.flightDetails.airlineId + this.flightDetails.airlineNumber
                  };
                  addAsNewSelectedSeat = false;
                }
              }
              totSeatPrice += +this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedSeatDetails[selectedSeatIndex].seatPrice;
              selectedSeatIndex++;
            });
          }
          if (addAsNewSelectedSeat) {
            this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedSeatDetails.push({
              seatRowNumber: passenger.selectedRowNumber,
              seatCoulmnName: passenger.selectedColumnName,
              seatPrice: passenger.selectedSeatPrice,
              boundOfferIndex: boundOfferIndex,
              flightIndex: flightSegmentIndex,
              flightNumber: this.flightDetails.airlineId + this.flightDetails.airlineNumber
            });
            totSeatPrice += +passenger.selectedSeatPrice;
          }
          //remove existing selected seat detail
          let passengerSeatDetails: PassengerSeatDetails[] = passengerDetail.passengerOtherDetails.passengerSeatDetails;
          let passengerSeatDetailsLength = passengerSeatDetails.length;
          if (passengerSeatDetailsLength > 0) {
            let passengerSeatIndex: any = 0;
            passengerSeatDetails.forEach((passengerSeatDetails: PassengerSeatDetails) => {
              if (passengerSeatDetails.boundOfferIndex === boundOfferIndex && passengerSeatDetails.flightIndex === flightSegmentIndex) {
                this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSeatDetails = this.passengerScreenPassengerDetails[
                  passengerIndex
                ].passengerOtherDetails.passengerSeatDetails.splice(passengerSeatIndex, 0);
              }
              passengerSeatIndex++;
            });
          }
          //end
        }
      });
      passengerIndex++;
    });
    updatedYourBookingScreenSelectedSeatDetails.push(selectedSeatDetail);
    yourBookingScreenData.selectedSeatItem = updatedYourBookingScreenSelectedSeatDetails;
    this.passengerDetailScreen.passengerDetail = this.passengerScreenPassengerDetails;
    let flightPrice: any = 0;
    let bagPrice: any = 0;
    let total: any = +parseFloat(totSeatPrice) + parseFloat(flightPrice) + parseFloat(bagPrice);
    yourBookingScreenData.booking.priceDetail.seatPrice = totSeatPrice;
    yourBookingScreenData.booking.priceDetail.price = total;
    let currency = yourBookingScreenData.booking.priceDetail.currency;
    this.confirmBookingScreen.postSeatSaleTicketDetail = {
      priceDetails: {
        flightPrice: '0',
        seatPrice: totSeatPrice,
        bagPrice: '0',
        cardFee: '0',
        totalCharge: total,
        priceCode: currency
      }
    };
    if (total > 0) {
      this.confirmBookingScreen.bookingType = 'post-booking-paid-sale-seat-form';
    } else {
      this.confirmBookingScreen.bookingType = 'post-booking-free-sale-seat-form';
    }
    this.sandboxPageStateService.updateConfirmBookingScreenData(this.confirmBookingScreen);
    yourBookingScreenData.displayConfirmBookingForm = true;
    this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);
    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreen);

    let patchSandboxSourceData: any = { mainMenu: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  storeOfferPricePrimeBooking() {
    let boundOfferIndex = this.seatSelectionScreen.boundOfferIndex;
    let flightSegmentIndex = this.seatSelectionScreen.flightSegmentIndex;
    let offerPriceScreenData: OfferPriceScreen = this.sandboxPageStateService.getOfferPriceScreenData();
    // store offer id to make order create request
    let offerPriceScreenPassengerSeatDetail = offerPriceScreenData.selectedSeatItem;
    let offerPriceScreenPassengerSeatDetailLength = offerPriceScreenPassengerSeatDetail.length;
    let updatedOfferPriceScreenSelectedSeatDetails: offerPriceScreenPassengerSelectedSeatDetail[] = [];
    if (offerPriceScreenPassengerSeatDetailLength > 0) {
      offerPriceScreenPassengerSeatDetail.forEach((seatDetail: offerPriceScreenPassengerSelectedSeatDetail) => {
        if (seatDetail.boundOfferIndex === boundOfferIndex && seatDetail.flightIndex === flightSegmentIndex) {
        } else {
          updatedOfferPriceScreenSelectedSeatDetails.push(seatDetail);
        }
      });
    }
    let selectedSeatDetail: offerPriceScreenPassengerSelectedSeatDetail = {
      offerId: this.seatSelectionScreen.offerId,
      owner: this.seatSelectionScreen.owner,
      responseId: this.seatSelectionScreen.responseID,
      offerDetail: [],
      boundOfferIndex: boundOfferIndex,
      flightIndex: flightSegmentIndex
    };
    //end
    offerPriceScreenData.offerPrice.boundAirlineOffer[boundOfferIndex].flightDetails[flightSegmentIndex].passengerSeatDetail = this.passengerSeatDetail;
    //store into passenger detail screen
    let passengerIndex = 0;
    let totSeatPrice: any = 0;
    this.passengerScreenPassengerDetails.forEach((passengerDetail: PassengerScreenPassenger) => {
      this.passengerSeatDetail.forEach((passenger: OfferPriceScreenPassengerSeatDetail) => {
        if (passenger.passengerId === passengerDetail.passengerId) {
          selectedSeatDetail.offerDetail.push({
            passengerId: passenger.passengerId,
            offerItemID: passenger.selectedOfferItemRef,
            seatDetail: {
              row: passenger.selectedRowNumber,
              column: passenger.selectedColumnName
            },
            descriptions: passenger.descriptions,
            price: passenger.price,
            currency: passenger.currency
          });
          let selectedPassengerSeatDetails: PassengerSeatDetails[] = passengerDetail.passengerOtherDetails.passengerSelectedSeatDetails;
          let selectedPassengerScreenLength = selectedPassengerSeatDetails.length;
          let addAsNewSelectedSeat: boolean = true;
          let selectedSeatIndex = 0;
          if (selectedPassengerScreenLength > 0) {
            selectedPassengerSeatDetails.forEach((selectedPassengerSeatDetail: PassengerSeatDetails) => {
              if (addAsNewSelectedSeat) {
                if (selectedPassengerSeatDetail.boundOfferIndex === boundOfferIndex && selectedPassengerSeatDetail.flightIndex === flightSegmentIndex) {
                  this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedSeatDetails[selectedSeatIndex] = {
                    seatRowNumber: passenger.selectedRowNumber,
                    seatCoulmnName: passenger.selectedColumnName,
                    seatPrice: passenger.selectedSeatPrice,
                    boundOfferIndex: boundOfferIndex,
                    flightIndex: flightSegmentIndex,
                    flightNumber: this.flightDetails.airlineId + this.flightDetails.airlineNumber
                  };
                  addAsNewSelectedSeat = false;
                }
              }
              totSeatPrice += +this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedSeatDetails[selectedSeatIndex].seatPrice;
              selectedSeatIndex++;
            });
          }
          if (addAsNewSelectedSeat) {
            this.passengerScreenPassengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedSeatDetails.push({
              seatRowNumber: passenger.selectedRowNumber,
              seatCoulmnName: passenger.selectedColumnName,
              seatPrice: passenger.selectedSeatPrice,
              boundOfferIndex: boundOfferIndex,
              flightIndex: flightSegmentIndex,
              flightNumber: this.flightDetails.airlineId + this.flightDetails.airlineNumber
            });
            totSeatPrice += +passenger.selectedSeatPrice;
          }
        }
      });
      passengerIndex++;
    });
    updatedOfferPriceScreenSelectedSeatDetails.push(selectedSeatDetail);
    offerPriceScreenData.selectedSeatItem = updatedOfferPriceScreenSelectedSeatDetails;
    this.passengerDetailScreen.passengerDetail = this.passengerScreenPassengerDetails;
    let flightPrice: any = offerPriceScreenData.offerPrice.priceDetail.flightPrice;
    let bagPrice: any = offerPriceScreenData.offerPrice.priceDetail.bagPrice;
    let total: any = +parseFloat(totSeatPrice) + parseFloat(flightPrice) + parseFloat(bagPrice);
    offerPriceScreenData.offerPrice.priceDetail.seatPrice = totSeatPrice;
    offerPriceScreenData.offerPrice.priceDetail.price = total;
    this.confirmBookingScreen.primeBookingTicketDetail.priceDetails.seatPrice = totSeatPrice;
    this.confirmBookingScreen.primeBookingTicketDetail.priceDetails.totalCharge = total;
    //end

    let availableOtherOffers: any[] = [];
    this.sandboxPageStateService.updateUpsellOffersData(availableOtherOffers);

    this.sandboxPageStateService.updateConfirmBookingScreenData(this.confirmBookingScreen);
    this.sandboxPageStateService.updateOfferPriceScreenData(offerPriceScreenData);
    this.sandboxPageStateService.updatePassengerDetailScreenData(this.passengerDetailScreen);

    let patchSandboxSourceData: any = { mainMenu: 'offer-price' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  closeSeat() {
    if (this.seatSelectionScreen.bookingType === 'offer-price-screen-seat') {
      let patchSandboxSourceData = { mainMenu: 'offer-price' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else if (this.seatSelectionScreen.bookingType === 'your-booking-screen-seat') {
      let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  updateDeckScreen() {
    let activeCabin = this.activeCabin;
    let nextActiveCabin = activeCabin + 1;
    if (typeof this.seatSelectionScreen.deckDetails[nextActiveCabin] === 'undefined') {
      nextActiveCabin = 0;
    }
    this.activeCabin = nextActiveCabin;
  }
}
